import { PreviewImageContainer } from 'modules/ScrShop/components/PersonalizedPreview/styles';
import { PreviewImage } from 'modules/ScrShop/components/PersonalizedPreview/PreviewImage';

export const GiftsPreview = ({ backgroundImage }) => (
  <PreviewImageContainer className="bg-preview" top={0} left={0} right={0} bottom={0} zIndex={2}>
    <PreviewImage image={backgroundImage} />
  </PreviewImageContainer>
);
